<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script lang="ts" setup>
import { useKasutajaStore } from "./stores/kasutajaStore";
// import useInterval from './composables/useInterval';
import { onMounted, inject } from "vue";
import providerKeys from "./providerKeys";
import { KasutajaTeenus } from "./core/kasutaja-teenus";
import { AuthTeenus } from "./core/auth-teenus";

const authTeenus = new AuthTeenus();
const kasutajaTeenus = inject(providerKeys.kasutajaTeenus);

const kasutajaStore = useKasutajaStore();
// const interval = useInterval(annaKasutajaInfo)

async function annaKasutajaInfo() {
  try {
    const kasutaja = await (kasutajaTeenus as KasutajaTeenus).kasutajaInfo();
    kasutajaStore.satiKasutaja(kasutaja);
  } catch (ex) {
    console.error(ex);
    // interval.stop();
  }
}

onMounted(async () => {
  const onAuth = await authTeenus.kontrolliAuthi();
  if (onAuth?.isAuth) {
    await annaKasutajaInfo();
  }
});
</script>

<style scoped></style>
